module.exports = __webpack_public_path__ + "0b0fdd3335b449bee153b4607721aa42.png";